(($) => {
  $(document).ready(() => {
    $('.slider-wrapper').each((index, item) => {
      const element = $(item);
      const itemCount = element.data('partner-slider-item-count');
      element.css('--partner-slider-item-count', itemCount);
    });
  });
})(jQuery);
